import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/lib/i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children, initialLang = "el" }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || initialLang);

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key, fallback) => {
      const v = translations[lang]?.[key];
      return v ?? fallback ?? key;
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
